module.exports = __webpack_public_path__ + "img/pattern2.8f0902f.svg";